import React, { createRef, FC, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useCommunity } from '../utils'
import { Spinner } from '../System'
import { StyledCommunityView } from '.'

const CommunityView: FC = () => {
  const history = useHistory()
  const [loading, setLoading] = useState(true)
  const { actions: { identifyCommunityUser } } = useCommunity()
  const iframeRef = createRef<HTMLIFrameElement>()

  const handleIframeMessage = (e: MessageEvent) => {
    const {
      event, title, url, path
    } = e.data

    if (event !== 'locationchange') {
      return
    }

    if (url) {
      return window.location.replace(url)
    }

    window.document.title = title

    if (path) {
      history.push(`/community${path}`)
    }
  }

  useEffect(() => {
    identifyCommunityUser()

    window.addEventListener('message', handleIframeMessage, false)

    return () => {
      window.removeEventListener('message', handleIframeMessage, false)
    }
  }, [])

  useEffect(() => {
    const iframe = iframeRef.current

    if (!iframe) {
      return
    }

    const cleanedPath = history.location.pathname.split('/community/')[1]
    iframe.src = `https://hello.community.socialcurator.com/${cleanedPath || '?iframe=true'}`
  }, [iframeRef.current])

  return (
    <StyledCommunityView>
      {loading && <Spinner isBlock />}
      <iframe
        ref={iframeRef}
        onLoad={() => setLoading(false)}
        allow="camera;microphone;display-capture;fullscreen"
        src="https://hello.community.socialcurator.com/c/home?automatic_login=true"
      />
    </StyledCommunityView>
  )
}

export default CommunityView
